import { getShipCompanyInfoRequest } from "@/api/abroad";
import store from "@/store";

// 初始化船公司信息
export const initShipCompanyInfo = async () => {
    // 获取船公司Logo信息数据
    const shipCompanyInfo = store.state.ship.shipComapyInfo;
    if (shipCompanyInfo && Object.keys(shipCompanyInfo).length > 0) {
        return;
    }
    const shipData = await getShipCompanyInfoRequest();
    store.commit("ship/changeShipComapyInfo", shipData);
};

// 是否是空对象
export const isEmptyObj = (data) => {
    if (data && Object.keys(data).length > 0) {
        return false;
    }
    return true;
};

export function getNodeDesc(code) {
    if (!code) {
        return "";
    }
    return store.state.txtdata.abroad.nodeDescEnum[code]
        ? `${store.state.txtdata.abroad.nodeDescEnum[code]}`
        : code;
}

// 展示节点
export const showAction = (citem) => {
    let result = citem.nodeAction || "";
    if (citem.statusCode) {
        result = `${result}（${getNodeDesc(citem.statusCode)}）`;
    }
    return result;
};
